// REACT IMPORTS
import { FC } from 'react'
import { useLocation } from 'react-router-dom'

// ABSOLUTE IMPORTS
import TopNav from '../components/TopNav'
import SubNav from '../components/SubNav'
import type { Maybe } from 'types/hoopla'

type HeaderV2UIProps = {
  alt: string
  isLibraryBrandingEnabled?: boolean
  libraryBrandingColor?: Maybe<string>
  libraryName?: string
  isDarkMode: boolean
  isFallbackNeeded: boolean
  onError: () => void
  logoUrl: string | null
  StaticHooplaLogo: FC<{ className?: string }>
}

const HeaderV2UI = ({
  alt,
  isLibraryBrandingEnabled,
  libraryBrandingColor,
  libraryName,
  isDarkMode,
  logoUrl,
  StaticHooplaLogo,
  onError,
  isFallbackNeeded,
}: HeaderV2UIProps) => {
  const location = useLocation()
  const path = location.pathname

  // Check if current path is browse or my hoopla related (settings excluded)
  const showSubNav =
    (path.startsWith('/browse') || path.startsWith('/my')) &&
    !path.startsWith('/my/settings')

  return (
    <header role="banner" data-testid="skeleton-header-v2">
      <TopNav
        alt={alt}
        libraryBrandingColor={libraryBrandingColor}
        logoUrl={logoUrl}
        StaticHooplaLogo={StaticHooplaLogo}
        onError={onError}
        isFallbackNeeded={isFallbackNeeded}
      />
      {showSubNav && (
        <SubNav
          isLibraryBrandingEnabled={isLibraryBrandingEnabled}
          libraryBrandingColor={libraryBrandingColor}
          libraryName={libraryName}
          isDarkMode={isDarkMode}
        />
      )}
    </header>
  )
}

export default HeaderV2UI
